import { Group, ActionIcon, Text } from '@mantine/core';
import { TimeInput } from '@mantine/dates';
import { IconCircleMinus } from '@tabler/icons-react';
import { TimeRange } from '@/pages/SchedulingPage/Availability/types';

interface TimeRangeInputProps {
  timeRange: TimeRange;
  onChange: (field: 'startTime' | 'endTime', value: string) => void;
  onRemove: () => void;
}

export function TimeRangeInput({ timeRange, onChange, onRemove }: TimeRangeInputProps) {
  return (
    <Group gap="xs" mb="sm" align="center" wrap="nowrap">
      <TimeInput
        value={timeRange.startTime}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('startTime', e.currentTarget.value)}
      />
      <Text size="sm" c="dimmed" style={{ flexShrink: 0 }}>
        to
      </Text>
      <TimeInput
        value={timeRange.endTime}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('endTime', e.currentTarget.value)}
      />
      <ActionIcon
        variant="subtle"
        onClick={onRemove}
        size="sm"
        color="#212529"
        aria-label="Remove time range"
        style={{ flexShrink: 0 }}
      >
        <IconCircleMinus size={24} />
      </ActionIcon>
    </Group>
  );
}
